<template>
  <section class="form-limited-width">
    <base-form-group
      :label="$t('src/components/hospitalform.3391')"
      :is-invalid="$v.localHospital.title.$error"
      :errors="{
        required: !$v.localHospital.title.required,
        allowSymbols: !$v.localHospital.title.allowSymbols
      }"
    >
      <base-input
        name="hospitalTitle"
        v-model="localHospital.title"
        @blur="$v.localHospital.title.$touch()"
        :is-invalid="$v.localHospital.title.$error"
      ></base-input>
    </base-form-group>
    <base-form-group
      :label="$t('general.address')"
      :is-invalid="$v.localHospital.address.$error"
      :errors="{
        allowSymbols: !$v.localHospital.address.allowSymbols
      }"
    >
      <base-textarea
        name="address"
        v-model="localHospital.address"
        @blur="$v.localHospital.address.$touch()"
      ></base-textarea>
    </base-form-group>
    <base-form-group
      :label="$t('src/components/hospitalform.231')"
      :is-invalid="$v.localHospital.description.$error"
      :errors="{
        allowSymbols: !$v.localHospital.description.allowSymbols
      }"
    >
      <base-textarea
        name="address"
        v-model="localHospital.description"
        @blur="$v.localHospital.description.$touch()"
      ></base-textarea>
    </base-form-group>
    <base-form-group :label="$t('systemAccess.endOfLife')">
      <base-calendar-wrap :isClearDate="true">
        <date-input v-model="localHospital.date_subscription_end"></date-input>
      </base-calendar-wrap>
    </base-form-group>
    <button type="button" class="btn btn-primary mt-3" @click="submit">
      <span v-if="saving" class="spinner-border spinner-border-sm"></span>{{ $t('button.save') }}
    </button>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { allowSymbols } from '@/modules/validators'
import { nowMoment } from '@/mixins/now-moment'

export default {
  name: 'HospitalForm',
  components: {
    BaseFormGroup: () => import('@/base/BaseFormGroup.vue'),
    BaseInput: () => import('@/base/BaseInput.vue'),
    BaseTextarea: () => import('@/base/BaseTextarea.vue'),
    BaseCalendarWrap: () => import('@/base/BaseCalendarWrap.vue'),
    DateInput: () => import('@/plugins/DateInput.vue')
  },
  mixins: [nowMoment],
  model: {
    prop: 'hospital'
  },
  props: {
    hospital: {
      type: Object,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localHospital: null
  }),
  validations() {
    return {
      localHospital: {
        title: {
          required,
          allowSymbols
        },
        address: {
          allowSymbols
        },
        description: {
          allowSymbols
        }
      }
    }
  },
  watch: {
    localHospital: {
      deep: true,
      handler() {
        this.$emit('input', this.localHospital)
      }
    }
  },
  created() {
    this.localHospital = Object.assign({}, this.hospital)
  },
  methods: {
    submit() {
      if (this.localHospital.date_subscription_end === '') this.localHospital.date_subscription_end = null
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit')
        this.$v.$reset()
      }
    }
  }
}
</script>
